import { render, staticRenderFns } from "./scatterChart2.vue?vue&type=template&id=136260be&scoped=true"
import script from "./scatterChart2.vue?vue&type=script&lang=js"
export * from "./scatterChart2.vue?vue&type=script&lang=js"
import style0 from "./scatterChart2.vue?vue&type=style&index=0&id=136260be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136260be",
  null
  
)

export default component.exports